import { RegisterAsGroupIcon } from "@/assets";
import NewUsersIcon24 from "@/assets/SVG/newUsersIcon24";
import { Modal } from "@/components";
import Badge from "@/components/badge/Badge";
import Card from "@/pages/admin/dashboard/components/Card";
import { Grid, useMediaQuery } from "@mui/material";
import TripsTable from "./TripsTable";

function PersonalInfo({ level, totalRecepted, tripTables }) {
  const md = useMediaQuery("(max-width:450px)");

  return (
    <>
      <Grid display={"flex"} flexDirection={md ? "column" : "row"} gap={"10px"}>
        <Grid
          display={"flex"}
          flexDirection={"column"}
          height={"stretch"}
          gap={"10px"}
          justifyContent={"space-between"}
        >
          <Badge level={level} />
          <Card
            title={"کل مراجعین پذیرش شده شما"}
            icon={<NewUsersIcon24 />}
            counter={totalRecepted ?? "-"}
            width="400px"
            unit={"نفر"}
          />
        </Grid>
        <Modal
          titleVariant="body2"
          title={"اردوهای شما"}
          icon={<RegisterAsGroupIcon />}
          width={md ? "100%" : "calc(100% - 420px)"}
        >
          {tripTables?.trips && <TripsTable trips={tripTables.trips} />}
        </Modal>
      </Grid>
    </>
  );
}

export default PersonalInfo;
